import { render } from "./InfoPopup.vue?vue&type=template&id=7e07ba30"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"

import "./InfoPopup.vue?vue&type=style&index=0&id=7e07ba30&lang=css"
script.render = render

export default script